import { Schema } from "effect"

// An editor draft, autosaved to the user's documents as "strategy-draft:<key>"
// (docs/design/0005, P4): UI state only, never a version. <key> is the strategy
// id, or "new" for the one strategy not saved yet. Read by the editor and by
// the tester (a pane can backtest a draft: strategy id "draft:<key>").

export const NEW_DRAFT = "new"

export const draftDocumentKey = (key: string): string => `strategy-draft:${key}`

/** A pane's strategy id for a draft. */
export const draftStrategyId = (key: string): string => `draft:${key}`

/** The draft key of a "draft:<key>" strategy id, or null. */
export const draftKeyOf = (strategyId: string): string | null => {
  const match = /^draft:([A-Za-z0-9_-]{1,64})$/.exec(strategyId)
  return match === null ? null : match[1]!
}

export const DraftDocument = Schema.Struct({
  name: Schema.String,
  source: Schema.String,
  /** The saved version the edit started from (null: never saved). */
  baseVersion: Schema.NullOr(Schema.Int),
  /** Epoch ms of the last edit (display only). */
  editedAt: Schema.Number
})
export type DraftDocument = typeof DraftDocument.Type

const decode = Schema.decodeUnknownOption(Schema.fromJsonString(DraftDocument))

/** A stored draft; null when there is none, it was cleared, or it doesn't decode. */
export const parseDraft = (json: string | null): DraftDocument | null => {
  if (json === null) return null
  const decoded = decode(json)
  return decoded._tag === "Some" ? decoded.value : null
}

/** A cleared draft (the documents API keeps keys; "null" reads back as no draft). */
export const CLEARED_DRAFT = "null"
